/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const IMAGE_VM_FIELD_KEYS = {
  disk: 'disk',
} as const;

export const IMAGE_VM_FIELD_KEY_LIST = [IMAGE_VM_FIELD_KEYS.disk] as const;

/** 系统盘操作（与 storage 的 dataDisk.* 命名空间隔离，避免 accessPolicy Map 撞名） */
export const IMAGE_VM_ACTION_KEYS = {
  add: 'systemDisk.add',
  select: 'systemDisk.select',
  edit: 'systemDisk.edit',
  remove: 'systemDisk.remove',
  switch: 'systemDisk.switch',
} as const;

export const IMAGE_VM_ACTION_KEY_LIST = Object.values(IMAGE_VM_ACTION_KEYS);

export const IMAGE_VM_OPTION_META_KEYS = {
  image: 'image',
};
